import { render, staticRenderFns } from "./ActiveButton.vue?vue&type=template&id=5ec8214a&scoped=true&"
import script from "./ActiveButton.vue?vue&type=script&lang=js&"
export * from "./ActiveButton.vue?vue&type=script&lang=js&"
import style0 from "./ActiveButton.vue?vue&type=style&index=0&id=5ec8214a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ec8214a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
